// extracted by mini-css-extract-plugin
export default {"tooltip":"PopMenu_tooltip__jqZG6","tooltip_opened":"PopMenu_tooltip_opened__reXso","trigger":"PopMenu_trigger__0IfNI"};